import { parseDateLikeHeader } from '@ooh/contracts';

/**
 * True when the currently-displayed month/half-month period rows resolved
 * to more than one distinct year AND none of their original source-column
 * headers carried an explicit year. A file with at least one explicit-year
 * header (`MM/YYYY`, or a combined-header inline/reversed year token) states
 * its own year split, so no review warning is needed even when its periods
 * span two years (see availability-profile-resolution's anchor-propagated
 * rule) — only the zero-anchor, today-relative-guess case
 * (CU-12472jzd1ea) needs the operator's review.
 */
export function deriveYearSpanWarning(
  periodColumns: { column: string; periodStart: string }[],
): boolean {
  const hasExplicitYearHeader = periodColumns.some(
    (pc) => parseDateLikeHeader(pc.column, 0)?.hasExplicitYear === true,
  );
  if (hasExplicitYearHeader) return false;

  const years = new Set(
    periodColumns
      .filter((pc) => pc.periodStart.length >= 4)
      .map((pc) => pc.periodStart.slice(0, 4)),
  );
  return years.size > 1;
}
